import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../ui/Dropdown';
import { useLanguage } from '../../../localization/useLanguage';
import { CHAT_COUNT_DISPLAY_MAX } from '../../../Helpers/Chat/Constant';
import {
    IconArchive,
    IconLink,
    IconMenuNewContact,
    IconMenuNewGroup,
    IconNewChat,
    IconOverflow,
    IconStar,
} from '../../../Components/Common/Icons';
import styles from './index.module.scss';

const formatCount = count => (count > CHAT_COUNT_DISPLAY_MAX ? `${CHAT_COUNT_DISPLAY_MAX}+` : count);

/**
 * Title bar of the chat list: the create menu and the overflow menu.
 *
 * @param title Screen title shown at the left.
 * @param archivedCount Number of archived conversations.
 * @param starredCount Number of starred messages.
 * @param isGroupChatEnabled Whether the group options may be offered.
 * @param onNewContact Opens the Contact List pop-up (FR60 screen 60.1).
 * @param onNewGroup Opens the New Group pop-up (FR60 screen 60.3).
 * @param onInvite Opens the invite pop-up.
 * @param onArchived Opens the archived list.
 * @param onStarred Opens the starred messages screen.
 */
export default function ChatListHeader({
    title,
    archivedCount = 0,
    starredCount = 0,
    isGroupChatEnabled = true,
    onNewContact,
    onNewGroup,
    onInvite,
    onArchived,
    onStarred,
}) {
    const { t } = useLanguage();

    return (
        <div className={styles.header}>
            <h3 className={styles.title}>{title}</h3>

            <div className={styles.actions}>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <button
                            type="button"
                            className={styles.iconBtn}
                            aria-label={t('chat.header.CREATE')}
                            title={t('chat.header.CREATE')}
                        >
                            <IconNewChat />
                        </button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className={styles.menu}>
                        <DropdownMenuItem onSelect={onNewContact}>
                            <IconMenuNewContact />
                            <span>{t('chat.header.NEW_CONTACT')}</span>
                        </DropdownMenuItem>
                        {isGroupChatEnabled && (
                            <DropdownMenuItem onSelect={onNewGroup}>
                                <IconMenuNewGroup />
                                <span>{t('chat.header.NEW_GROUP')}</span>
                            </DropdownMenuItem>
                        )}
                    </DropdownMenuContent>
                </DropdownMenu>

                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <button
                            type="button"
                            className={styles.iconBtn}
                            aria-label={t('chat.header.MORE')}
                            title={t('chat.header.MORE')}
                        >
                            <IconOverflow />
                        </button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className={styles.menu}>
                        <DropdownMenuItem onSelect={onInvite}>
                            <IconLink />
                            <span>{t('chat.header.INVITE')}</span>
                        </DropdownMenuItem>
                        <DropdownMenuItem onSelect={onArchived}>
                            <IconArchive />
                            <span>{t('chat.header.ARCHIVED')}</span>
                            <span className={styles.count}>{formatCount(archivedCount)}</span>
                        </DropdownMenuItem>
                        <DropdownMenuItem onSelect={onStarred}>
                            <IconStar />
                            <span>{t('chat.header.STARRED')}</span>
                            <span className={styles.count}>{formatCount(starredCount)}</span>
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </div>
    );
}
